module.exports = __webpack_public_path__ + "static/media/a8chat_icon.8ae1d21a.svg";